/* eslint-disable import/prefer-default-export,react/prop-types */
import React from 'react';
// apollo
import { Query as ApolloQuery, Mutation as ApolloMutation } from 'react-apollo';
// our components
import GraphqlErrorHandler from 'components/common/Query/GraphqlErrorHandler';

/**
 * @description
 * Render Query apollo component.
 *
 * @param {Object} prop - Component props.
 */
export const Query = ({ children, ...rest }) => (
  <ApolloQuery errorPolicy="all" {...rest}>
    {result => (
      <GraphqlErrorHandler error={result.error}>
        {children(result)}
      </GraphqlErrorHandler>
    )}
  </ApolloQuery>
);

/**
 * @description
 * Render Mutation apollo component.
 *
 * @param {Object} prop - Component props.
 */
export const Mutation = ({ children, ...rest }) => (
  <ApolloMutation {...rest}>
    {(trigger, result) => (
      <GraphqlErrorHandler error={result.error}>
        {children(trigger, result)}
      </GraphqlErrorHandler>
    )}
  </ApolloMutation>
);
